import { useEffect, useState } from 'react';

import { setSentryUser } from 'src/modules/app/components/Providers/Telemetry/Sentry';
import { PartnerKind, useProfileQuery } from 'src/shared/graphql/generated';
import { useSplit } from 'src/shared/hooks';
import type { UserWithAdditionalAttributes } from 'src/shared/hooks/useSplit';
import { identify } from 'src/shared/telemetry';

export const useSplitAfterAuth = () => {
  const [authed, setAuthed] = useState<boolean>(false);

  const { data: profileData } = useProfileQuery();
  const {
    updateUserId: updateSplitUserId,
    updateAttributes: updateSplitAttributes,
    client,
  } = useSplit();
  const user = profileData?.profile?.user;

  useEffect(() => {
    if (user) {
      const splitUserWithIsInsurance = {
        ...user,
        isInsurance: user.orgs[0].partner?.kind === PartnerKind.Insurance,
      };
      const { email, id } = user;
      setSentryUser(id, email);
      updateSplitUserId(id?.toString());
      updateSplitAttributes(
        splitUserWithIsInsurance as UserWithAdditionalAttributes,
      );
      void identify({ userId: id, email });
      setAuthed(true);
    }
  }, [user, updateSplitAttributes, updateSplitUserId]);

  return { authed, client };
};
